import { Logout } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { DarkModeSwitch } from '@/components/DarkModeSwitch/DarkModeSwitch'
import { useSidebar } from '@/components/ui/sidebar'
import { useLogout } from '@/hooks/useLogout'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

export const SidebarLogout = () => {
  const { logout } = useLogout()
  const { t } = useTranslation()
  const { state } = useSidebar()

  const isCollapsed = state === 'collapsed'
  return (
    <div className="flex justify-between items-center rounded-lg bg-baseColor py-3 px-4 gap-3 group-data-[collapsible=icon]:px-2 group-data-[collapsible=icon]:flex-col-reverse">
      <div
        className="flex items-center gap-2 cursor-pointer group-data-[collapsible=icon]:justify-center"
        onClick={logout}
        role="button"
        tabIndex={0}
      >
        <Logout
          size={isCollapsed ? 24 : 20}
          color={SocialMirrorPalette.dynamicRed}
          className="flex-shrink-0"
        />
        {!isCollapsed && (
          <p className="text-dynamicRed text-sm font-medium">
            {t('dashboard.sidebar.logOut')}
          </p>
        )}
      </div>
      <DarkModeSwitch />
    </div>
  )
}
